<template>
    <div>
        <h1 class="display-heading">Employer Sponsored Companies</h1>
        <div v-for="(company, index) in list" class="card mb-3" :key="index">
            <div class="card-header">
                {{ index + 1 }}. {{ company.companyName }}
            </div>
            <div class="card-body">
                <p><b>Registration Number</b>: {{ company.companyRegistrationNumber }}</p>
                <p><b>Email Address</b>: {{ company.emailAddress }}</p>
                <p><b>Contact Person Name</b>: {{ company.contactPersonName }}</p>
                <p><b>Contact Phone Number</b>: {{ company.phoneNumber }}</p>
                <p><b>Address</b>: {{ getAddress(company.addressLine1, company.addressLine2, company.addressPoscode,
                    company.addressCity, company.addressState) }}</p>
            </div>
            <div class="card-footer">
                <router-link type="button" class="btn btn-primary" target="_blank"
                    :to="{ name: 'admin-company-tier-detail', params: { 'id': company.companyId } }">
                    View Tiers
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    'name': 'AdminManageCompanyTier',
    'computed': {

    },
    data () {
        return {
            'list': []
        };
    },

    'methods': {
        getCompanies () {
            this.axios.get('Debug/EmployerSponsoredCompanies').then(({ data }) => {
                const list = data;
                if (list) {
                    this.list = data;
                }
            });
        },
        getAddress (addressLine1, addressLine2, addressPostcode, addressCity, addressState) {
            let list = [];
            if (addressLine1) {
                list.push(addressLine1);
            }
            if (addressLine2) {
                list.push(addressLine2);
            }
            if (addressPostcode) {
                list.push(addressPostcode);
            }
            if (addressCity) {
                list.push(addressCity);
            }
            if (addressState) {
                list.push(addressState);
            }
            return list.join(', ');
        }
    },
    'mounted' () {
        this.getCompanies();
    }
};
</script>
